import React from 'react';
import { Box } from '@mui/material';
import TypeBadge from 'features/feedback/shared/TypeBadge';
import StatusChip from 'features/feedback/shared/StatusChip';
import { AdminFeedbackTO } from 'features/feedback/shared/feedback.types';

const TriageTable: React.FC<{ items: AdminFeedbackTO[]; selectedId: number | null; onSelect: (id: number) => void }> = ({ items, selectedId, onSelect }) => (
  <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
    {items.map((it) => (
      <Box
        key={it.id}
        role="button"
        tabIndex={0}
        onClick={() => onSelect(it.id)}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(it.id); } }}
        sx={{
          display: 'flex', alignItems: 'center', gap: 1.5, p: '10px 12px', cursor: 'pointer',
          border: `1px solid ${selectedId === it.id ? '#3B2C93' : '#E7E7E7'}`,
          background: selectedId === it.id ? 'rgba(59,44,147,.06)' : '#fff', borderRadius: '10px',
        }}
      >
        <TypeBadge type={it.type} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box sx={{ fontSize: 14, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{it.title}</Box>
          <Box sx={{ fontSize: 12, color: '#7A7F88' }}>{it.authorName}</Box>
        </Box>
        <StatusChip status={it.status} />
      </Box>
    ))}
  </Box>
);

export default TriageTable;
